if (!customElements.get('how-to-play-search')) {
  customElements.define(
    'how-to-play-search',
    class HowToPlaySearch extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('input');
        this.grid = document.getElementById(this.getAttribute('data-grid'));
        this.emptyState = document.getElementById(this.getAttribute('data-empty-state'));
        this.items = this.grid ? Array.from(this.grid.querySelectorAll('[data-name]')) : [];
        this.input.addEventListener('input', this.onInput.bind(this));
      }

      onInput() {
        const query = this.input.value.trim().toLowerCase();
        let visibleCount = 0;

        this.items.forEach((item) => {
          const matches = item.getAttribute('data-name').toLowerCase().includes(query);
          item.hidden = !matches;
          if (matches) visibleCount += 1;
        });

        if (this.emptyState) this.emptyState.hidden = visibleCount !== 0;
      }
    }
  );
}
